import {
	SHOW_AUTH_MODAL,
	HIDE_TC_MODAL,
} from '@reduxLocal/actions/types';
import { store } from '@reduxLocal/persistState';

const getTCConfirm = () => {
	const dispatch = store.dispatch;
	let settled = false;
	let unsubscribe;
	/** True once TC sheet has been opened for this wait (avoids rejecting on idle state before SHOW_TC_MODAL). */
	let sawTcModalOpen = false;

	const promise = new Promise((resolve, reject) => {
		const handler = () => {
			if (settled) return;

			const currentValue = store.getState().modals.tcModal;

			if (currentValue.modalDisplayed && currentValue.userId) {
				sawTcModalOpen = true;
			}

			if (currentValue.accepted) {
				settled = true;
				unsubscribe();
				resolve(true);
				return;
			}

			if (!currentValue.modalDisplayed) {
				// Ignore spurious updates until the terms modal has actually been shown (OAuth path dispatches
				// HIDE_LOADING_MODAL before SHOW_TC_MODAL, often with a delay — idle tcModal looks like "dismissed").
				if (!sawTcModalOpen) {
					return;
				}

				settled = true;
				unsubscribe();

				// Check if user explicitly declined (intentional cancel) BEFORE dispatching HIDE_TC_MODAL
				// DECLINE_TERMS sets accepted to false, and it's dispatched before HIDE_TC_MODAL in TCModal
				const wasExplicitlyDeclined = currentValue.accepted === false;

				dispatch({ type: HIDE_TC_MODAL });

				if (!wasExplicitlyDeclined) {
					// Modal was closed but not explicitly declined - show error
					setTimeout(() => {
						dispatch({
							type: SHOW_AUTH_MODAL,
							data: {
								content:
									'You must accept the terms and conditions to continue.',
								type: 'error',
							},
						});
					}, 1000);
				} else {
					console.log(
						'[getTCConfirm] User declined terms, not showing error message'
					);
				}

				reject(
					new Error(
						'You must accept the terms and conditions to continue.'
					)
				);
			}
		};

		unsubscribe = store.subscribe(handler);
	});

	const timeoutPromise = new Promise((_, reject) => {
		setTimeout(() => {
			if (settled) return;
			settled = true;
			unsubscribe?.();
			dispatch({ type: HIDE_TC_MODAL });
			reject(new Error('Timeout: The operation took too long.'));
		}, 600000);
	});

	return Promise.race([promise, timeoutPromise]);
};


export default getTCConfirm;
